import Axios from 'axios';

export const httpGet = async (
  environment: string,
  path: string,
  options?: Record<string, unknown>
) => {
  const url = `${environment}${path}`;
  const response = await (await Axios.get(url, { ...options })).data;
  return response;
};

export const httpPost = async (
  environment: string,
  path: string,
  body: Record<string, unknown>,
  options?: Record<string, unknown>
) => {
  const url = `${environment}${path}`;
  const response = await (await Axios.post(url, body, { ...options })).data;
  return response;
};
